import { useEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Headermenu.js sets window.history.scrollRestoration = "manual", so the
// browser will never restore scroll position on its own — this component
// has to remember and restore it for Back/Forward navigation.
const scrollPositions = new Map();

const ScrollToTop = () => {
  const { pathname, key } = useLocation();
  const navigationType = useNavigationType();
  const prevKey = useRef(key);

  useEffect(() => {
    scrollPositions.set(prevKey.current, window.scrollY);

    if (navigationType === "POP" && scrollPositions.has(key)) {
      window.scrollTo(0, scrollPositions.get(key));
    } else {
      window.scrollTo(0, 0);
    }

    prevKey.current = key;
  }, [pathname, key, navigationType]);

  return null;
};

export default ScrollToTop;
